// EventContext.js
import { createContext, useEffect, useState } from "react";
import { subscribeToEventData } from "../utils/fetchEventData";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const EventContext = createContext();

const EventProvider = ({ children }) => {
  const [eventList, setEventList] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);

  // 認証ユーザーの取得
  useEffect(() => {
    const auth = getAuth();
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });

    return () => unsubscribeAuth();
  }, []);

  // currentUser が存在する時だけイベントデータを購読
  useEffect(() => {
    if (!currentUser) return;

    const unsubscribeEvents = subscribeToEventData(setEventList);

    return () => unsubscribeEvents();
  }, [currentUser]);

  return (
    <EventContext.Provider value={{ eventList, setEventList }}>
      {children}
    </EventContext.Provider>
  );
};

export { EventContext, EventProvider };
